import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import IMG1 from "../../../images/industries/education/Course-Management.webp";
import IMG2 from "../../../images/industries/education/Multi-Language-Support.webp";
import IMG3 from "../../../images/industries/education/Personalized-Learning.webp";
import IMG4 from "../../../images/industries/education/Flexible-Access.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Demandfeatures(props) {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const getActiveClass = (index, className) =>
    toggleState === index ? className : "";
  return (
    <section className="tekrevol_gray_bg p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Digital Market">
              <h2>
                Simplify Learning with Our Educational Software Development
                Services
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              We aim to continuously innovate online education and build a
              collaborative ecosystem that encourages the maximum interaction of
              students through digital learning. Our education software
              developers strive to create robust products that create an impact
              on the user while providing them with an enjoyable learning
              experience to maximize engagement. From automated learning
              management systems to customized e-learning applications, we
              facilitate our clients' diverse domains of education software
              development services.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                0,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(0)}
            >
              <LazyLoadImage
                src={IMG1}
                effect="blur"
                alt="IMG1"
                className="img-fluid"
              />
              <h6>E-learning Application Development</h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                1,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(1)}
            >
              <LazyLoadImage
                src={IMG2}
                effect="blur"
                alt="IMG2"
                className="img-fluid"
              />
              <h6>Learning Management System</h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                2,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(2)}
            >
              <LazyLoadImage
                src={IMG3}
                effect="blur"
                alt="IMG3"
                className="img-fluid"
              />
              <h6>School Management Software</h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                3,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(3)}
            >
              <LazyLoadImage
                src={IMG4}
                effect="blur"
                alt="IMG4"
                className="img-fluid"
              />
              <h6>Customized Education Software</h6>
            </div>
          </Col>

          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 0
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              Enhance the process of conducting learning activities with our
              bespoke education app development services. We possess the
              expertise in creating highly interactive, and user-friendly
              e-learning platforms customized to your unique requirements.
              Further, we ensure a dynamic learning experience for students and
              educators from intuitive user interfaces to seamless content
              delivery.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 1
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              Scale up your institution with our efficient Learning Management
              System (LMS) solutions. We have designed our LMS platforms to
              streamline course management, facilitate online learning, and
              track student progress effectively. Moreover, our education
              software company integrates robust features such as content
              management, assessment tools, and analytics to ensure a
              personalized learning experience.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 2
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              Simplify and automate administrative processes with our innovative
              school management software. Our educational software developers
              have included a wide range of functionalities like student
              enrollment, attendance tracking, fee management, academic
              scheduling, and communication tools. So, institutes can enhance
              efficiency and elevate overall organizational performance with our
              scalable educational software development.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 3
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              Unlock the full power of technology in education by opting for
              tailor-made software solutions. From a specially designed
              educational app to a platform for assessment and a student
              engagement app, we've got you all covered. Our team of educational
              software developers works closely with you to understand your
              particular needs. That is how we produce customized software
              solutions that align perfectly with your vision and goals.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Demandfeatures;
